const SearchIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 60 60"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <defs />
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="2_Home"
        transform="translate(-924.000000, -49.000000)"
        stroke="#FFFFFF"
        strokeWidth="4.14814815"
      >
        <g
          id="Group-4"
          transform="translate(924.000000, 49.000000)"
        >
          <g
            id="ic-search"
            transform="translate(14.000000, 13.000000)"
          >
            <circle
              id="shape"
              cx="13.3776949"
              cy="13.3776949"
              r="11.3036208"
            />
            <path
              d="M21.8673858,21.8673858 L31.6433936,31.6433936"
              id="line"
              strokeLinecap="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SearchIcon;
